import "./sidebar.css";
import {
  RssFeed,
  Chat,
  PlayCircleFilledOutlined,
  Group,
  Bookmark,
  HelpOutline,
  WorkOutline,
  Event,
  School,
} from "@mui/icons-material";
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import FeedbackIcon from '@mui/icons-material/Feedback';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import SocialContext from "../../context/SocialContext";
import Conform from "../../components/conform/Conform";

export default function Sidebar() {
  const { user: currentuser, logoutfun, setOpen, setconformAction,conformAction,setconformMessage } = useContext(SocialContext);
  const navigate = useNavigate();

  const controllogoutfun = () => {
    setconformMessage("Do you want to logout?");
    setconformAction("forlogout");
    setOpen(true);
  }


  return (

    <div className="sidebar">
      <Conform/>
      <div className="sidebarWrapper">
        <ul className="sidebarList">
          <li className="sidebarListItem">
            <Link to={'/'} className="menulink"><HomeIcon className="sidebarIcon" /></Link>
            <Link to={'/'} className="menulink"><span className="sidebarListItemText">Homepage</span></Link>
          </li>
          <li className="sidebarListItem">
            <Link to={'/profile/' + currentuser._id} className="menulink"><PersonIcon className="sidebarIcon" /></Link>
            <Link to={'/profile/' + currentuser._id} className="menulink"><span className="sidebarListItemText">My Account</span></Link>
          </li>
          <li className="sidebarListItem">
            <Link to={'/share'} className="menulink"><AddCircleRoundedIcon className="sidebarIcon" /></Link>
            <Link to={'/share'} className="menulink"><span className="sidebarListItemText">New Post</span></Link>
          </li>
          <li className="sidebarListItem">
            <Link to={'/friends'} className="menulink"><Group className="sidebarIcon" /></Link>
            <Link to={'/friends'} className="menulink"><span className="sidebarListItemText">Network</span></Link>
          </li>
          <li className="sidebarListItem">
            <a target="_blank" className="menulink" href="https://ekarts.netlify.app/"><LocalGroceryStoreIcon className="sidebarIcon" /></a>
            <a target="_blank" className="menulink" href="https://ekarts.netlify.app/"><span className="sidebarListItemText">Shop</span></a>
          </li>
          <li className="sidebarListItem">
            <Link to={'/feedback'} className="menulink"><FeedbackIcon className="sidebarIcon" /></Link>
            <Link to={'/feedback'} className="menulink"><span className="sidebarListItemText">Feedback</span></Link>
          </li>
          <li className="sidebarListItem" style={{'marginBottom':'0px'}}>
            <LogoutIcon onClick={controllogoutfun} className="menulink sidebarIcon" />
            <span onClick={controllogoutfun} className="menulink sidebarListItemText">Logout</span>
          </li>
        </ul>
      </div>
    </div>
  );
}